import { render, staticRenderFns } from "./TakipVeTahsilatWidgetGrafik.vue?vue&type=template&id=6143fc2f&scoped=true"
import script from "./TakipVeTahsilatWidgetGrafik.vue?vue&type=script&lang=ts"
export * from "./TakipVeTahsilatWidgetGrafik.vue?vue&type=script&lang=ts"
import style0 from "./TakipVeTahsilatWidgetGrafik.vue?vue&type=style&index=0&id=6143fc2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143fc2f",
  null
  
)

export default component.exports